import React from "react";
import SEO from "../components/SEO";

export default function StoryPage() {
  return (
    <div>
      <SEO
        title="Nuestra historia · Mimes Gourmet"
        description="Del Pirineo aragonés a tu mesa: cómo nace Mimes Gourmet, un obrador artesano en Graus (Huesca) que cocina mermeladas en lotes pequeños con fruta fresca."
        path="/historia"
        image="/products/frutos-rojos.webp"
        type="website"
      />
      <section className="relative h-[60vh] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/18100810/pexels-photo-18100810.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600"
          alt="Pirineo aragonés"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--brand-primary)]/70 to-transparent flex items-end">
          <div className="max-w-7xl mx-auto w-full px-5 sm:px-8 pb-16 text-white">
            <p className="eyebrow text-[color:var(--brand-terracotta)] mb-4">Nuestra historia</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-tight max-w-3xl">
              Del Pirineo, con <span className="italic">paciencia</span> y mimo.
            </h1>
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-20 space-y-6 text-[color:var(--brand-neutral)] leading-relaxed">
        <p>
          Mimes Gourmet nació en <strong>Graus, Huesca</strong>, en un obrador donde el conocimiento
          de generaciones anteriores toma forma de mermeladas con calma, con detalle, con cariño
          que merecen compartirlas.
        </p>
        <p>
          Elaboramos <strong>lotes pequeños</strong> de fruta fresca de temporada, cocinada a fuego lento,
          sin conservantes, sin aromas, sin atajos, al ritmo que marca la naturaleza.
        </p>
        <p>
          Somos fieles a la tradición, pero nos gustan también las combinaciones inesperadas:
          membrillo con café, manzana con menta, cebolla con trufa.
        </p>
        <p className="font-serif text-2xl italic text-[color:var(--brand-primary)] pt-4">
          &ldquo;Mimar es cocinar sin prisa.&rdquo;
        </p>
      </section>
    </div>
  );
}
